import axios from '../../../axios';
import IFilters from '../types/IFilters';
import NoteDTO from '../types/NoteDTO';
import UnmarkedNoteDTO from '../types/UnMarkedNotesDTO';

const url = 'invoicingservice/api/note';

export const getAllNotes = (clientId: string, toggleParent: string) =>
  axios.get(`${url}?clientId=${clientId}&toggleParent=${toggleParent}`);
export const createNote = (note: NoteDTO) => axios.post(url, note);
export const updateNote = (note: NoteDTO) => axios.put(url, note);
export const archiveNote = (id: string) => axios.post(`${url}/markArchived?id=${id}`);
export const unarchiveNote = (id: string) => axios.post(`${url}/markUnarchived?id=${id}`);
export const getNotesByClientIdAndClientContactId = (
  clientId: string,
  clientContactId: string,
  toggleParent: string
) =>
  axios.get(
    `${url}/get-client-contact?clientId=${clientId}&clientContactId=${clientContactId}&toggleParent=${toggleParent}`
  );
export const getAllRecruiterNotes = (userId: string, toggleParent: string) =>
  axios.get(`${url}/get-recruiter-notes/${userId}?toggleParent=${toggleParent}`);
export const getAllNotesByWorkspaceId = (payload: IFilters) =>
  axios.post(`${url}/get-all-notes-by-workspaceid`, payload);
export const getNoteById = (noteId: string) => axios.get(`${url}/get-note-by-id?noteId=${noteId}`);
export const getAllNotesTags = () => axios.get(`${url}/tags`);
export const updateUnmarkedNotes = (note: UnmarkedNoteDTO) =>
  axios.post(`${url}/unmarked-notes-update`, note);
